export enum DisplayConfigurationPageCaptionEnum {
    Automatic = 'Automatic',
    LastPage = 'LastPage',
    None = 'None',
  }
